import { queryOptions } from "@tanstack/react-query";
import * as noteListsApi from "@/lib/api/noteLists";
import { queryKeys } from "@/lib/query-keys";

export const noteListsQueryOptions = (userId?: string) =>
  queryOptions({
    queryKey: queryKeys.noteLists.list(userId),
    queryFn: ({ signal }) => noteListsApi.fetchNoteLists({ signal }),
    enabled: !!userId,
  });

export const noteListQueryOptions = (listId: string) =>
  queryOptions({
    queryKey: queryKeys.noteLists.detail(listId),
    queryFn: ({ signal }) => noteListsApi.fetchNoteList(listId, { signal }),
    enabled: !!listId,
  });
